// import SaleUtils from '@/services/SaleUtils'
import { required } from '@/services/validations'
// import ProductPricesHeaders from './headersPrice'
// import BranchOfficeMdl from '@/models/General/GBranchOffice'
// import BranchOfficeService from '@/services/api/branchOffice'

export default (branch=[])=>[
    // {
    //     name:'type_discount',
    //     type:'switch',
    //     flex: {
    //         sm12: true,
    //         lg12: true,
    //     },
    //     props: {
    //         label:'Monto / Porcentaje'
    //     }
    // },
    {
        name: 'branch_office_id',
        type: 'select',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            
            itemText: 'name',
            itemValue: 'id',
            label: 'Sucursal',
            items: branch,
            //noObject: true,
            // paramSearch: 'name',
            rules: [required],
        },
    },
    {
        //comercial fields[0] - Precio Costo
        name: 'quantity_discount',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Cantidad ',
            rules: [required],
            suffix: '',
            //   prefix : '$',
        },
    },
    {
        //comercial fields[1] - Precio Venta
        name: 'new_price',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg4: true,
        },
        props: {
            label: 'Nuevo Precio $',
            rules: [required],
            suffix: '',
        },
    },
    // {
    //     //comercial fields[1] - Precio Venta
    //     name: 'new_percentage',
    //     type: 'percentage-field',
    //     flex: {
    //         sm6: true,
    //         lg4: true,
    //     },
    //     props: {
    //         label: 'Porcentaje %',
    //         rules: typeDiscount ? [required]:[],
    //         suffix: '%',
    //     },
    // },
    // {
    //     //comercial fields[0] - Precio Costo
    //     name: 'new_percentage',
    //     type: 'currency-field',
    //     flex: {
    //         sm6: true,
    //         lg4: true,
    //     },
    //     props: {
    //         label: 'Porcentaje ',
    //         rules: [required],
    //         suffix: '%',
    //         //   prefix : '$',
    //     },
    // },
    // {
    //   name: 'btn',
    //   type: 'btn',
    //   flex: {
    //     sm6: true,
    //     lg4: true,
    //   },
    //   props:{
        
    //     text: 'click'
    //   }
    // },
    // {
    //     props: { title: 'Precios por sucursal' },
    //     type: 'section-field',
    //     flex: {
    //         'mb-3': true,
    //         xs12: true,
    //     },
    // },
    // {
    //     name: 'branch_office_selected',
    //     type: 'tableField',
    //     flex: {
    //         'pt-0': true,
    //         xs12: true,
    //     },
    //     props: {
    //         checkable: true,
    //         class: 'v-card elevation-2 mb-4',
    //         headers: ProductPricesHeaders,
    //         noActions: true,
    //         noDataText: 'Sin esquemas.',
    //         noFilter: true,
    //         noExport: true,
    //         noHelper: true,
    //         noPagination: true,
    //         noSearch: true,

    //         showNativePagination: true,
    //         //showPicker: true,
    //         style: {
    //             //margin: "0 -24px"
    //         },
    //         toolbarTitle: 'Detalle descuento de precios por cantidad',
    //         toolbarColor: 'primary',
    //         toolbarDark: true,
    //         toolbarDense: true,
    //     },
    // },
]
